export function modal() {
  const overlay = document.querySelector('.js-modalOverlay');
  const closeBtnList = document.querySelectorAll('.js-modalClose');
  const triggerList = document.querySelectorAll('.js-modalTrigger');
  const targetList = document.querySelectorAll('.js-modalBody');

  if (!overlay) {
    return;
  }

  for (let i = 0; i < triggerList.length; i++) {
    // リンクをクリックした時にオーバーレイを表示し、表示するモーダルの属性を取得する
    triggerList[i].addEventListener('click', function() {
      overlay.classList.add('is-show');
      var openTarget = this.dataset.modalTarget;

      // 一致した属性のモーダルにアクティブクラスを付与
      for (let i = 0; i < targetList.length; i++) {
        let target = targetList[i].dataset.modal;
        if (target == openTarget) {
          targetList[i].classList.add('is-show');
        } else {
          targetList[i].classList.remove('is-show');
        }
      }
    });
  }

  // 閉じるボタン
  for (let i = 0; i < closeBtnList.length; i++) {
    closeBtnList[i].addEventListener('click', function() {
      let closest = this.closest('.js-modalBody');
      let iframe = closest.querySelector('iframe');
      if (iframe) {
        iframe.src = iframe.src; // 動画を停止
      }
      overlay.classList.remove('is-show');
      closest.classList.remove('is-show');
    });
  }

  // モーダル本体クリック時はオーバーレイにイベントを伝播させない
  for (let i = 0; i < targetList.length; i++) {
    targetList[i].addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  // オーバーレイをクリックした時
  overlay.addEventListener('click', function() {
    this.classList.remove('is-show');
    for (let i = 0; i < targetList.length; i++) {
      let iframe = targetList[i].querySelector('iframe');
      if (iframe) {
        iframe.src = iframe.src; // 動画を停止
      }
      targetList[i].classList.remove('is-show');
    }
  });
}
